<template>
  <div class="main">
    <a-form
      id="formLogin"
      class="user-layout-login"
      ref="formLogin"
      :form="form"
      @submit="handleSubmit"
    >
      <a-tabs
        :activeKey="customActiveKey"
        :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
        @change="handleTabClick"
      >
        <a-tab-pane key="password" tab="账号密码登录">
          <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px;" message="账户或密码错误" />
          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="用户名"
              v-decorator="[
                'username',
                {rules: [{ required: true, message: '请输入电话' }, { validator: handleUsernameOrEmail }], validateTrigger: 'change'}
              ]"
            >
              <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              type="password"
              autocomplete="false"
              placeholder="密码"
              v-decorator="[
                'password',
                {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
              ]"
            >
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
          <a-row :gutter="16">
            <a-col class="gutter-row" :span="16">
              <a-form-item>
                <a-input size="large" type="text" placeholder="验证码" v-decorator="['vcode', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">
                  <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>
            </a-col>
            <a-button type="link" class="gutter-row imgVcode" :span="8" :loading="imgVcode.loading" @click="getImgVCode" v-html="imgVcode.image">
            </a-button>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="code" tab="手机号登录">
          <a-form-item>
            <a-input size="large" type="text" placeholder="手机号" v-decorator="['username', {rules: [{ required: true, pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号' }], validateTrigger: 'change'}]">
              <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>
          <a-row :gutter="16">
            <a-col class="gutter-row" :span="16">
              <a-form-item>
                <a-input size="large" type="text" placeholder="验证码" v-decorator="['vcode', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">
                  <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>
            </a-col>
            <a-button type="link" class="gutter-row imgVcode" :span="8" :loading="imgVcode.loading"  @click="getImgVCode" v-html="imgVcode.image">
            </a-button>
          </a-row>
          <a-row :gutter="16">
            <a-col class="gutter-row" :span="16">
              <a-form-item>
                <a-input size="large" type="text" placeholder="验证码" v-decorator="['password', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">
                  <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <a-button
                class="getCaptcha"
                tabindex="-1"
                :disabled="state.smsSendBtn"
                @click.stop.prevent="getCaptcha"
                v-text="!state.smsSendBtn && '获取验证码' || (state.time+' s')"
              ></a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="loginLoading"
          :disabled="loginLoading"
        >确定</a-button>
      </a-form-item>

      <div class="user-login-other">
        <span>其他登录方式</span>
        <a>
          <a-icon class="item-icon" type="alipay-circle"></a-icon>
        </a>
        <a>
          <a-icon class="item-icon" type="taobao-circle"></a-icon>
        </a>
        <a>
          <a-icon class="item-icon" type="weibo-circle"></a-icon>
        </a>
      </div>
    </a-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { sendSmsVcode, getVerifyCode } from '../../api/login';

export default {
  data() {
    return {
      customActiveKey: 'password',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      isLoginError: false,
      requiredTwoStepCaptcha: false,
      form: this.$form.createForm(this),
      imgVcode: {
        loading: false,
        image: '',
        vid: '',
        expires: 60,
      },
      state: {
        vcode: '',
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false,
      },
    };
  },
  created() {
    this.getImgVCode();
  },
  computed: {
    ...mapState({
      loginLoading: (state) => state['@@loading'].effects.login,
    }),
  },
  methods: {
    ...mapActions(['login', 'Logout']),
    // 获取图片验证码
    async getImgVCode() {
      this.imgVcode.loading = true;
      const { data } = await getVerifyCode();
      this.imgVcode.vid = data.vid;
      this.imgVcode.image = data.image;
      this.imgVcode.expires = data.expires;
      this.imgVcode.loading = false;
    },
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      const { state } = this;
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
      if (regex.test(value)) {
        state.loginType = 0;
      } else {
        state.loginType = 1;
      }
      callback();
    },
    handleTabClick(key) {
      this.customActiveKey = key;
      // this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault();
      const {
        form: { validateFields },
        state,
        customActiveKey,
        login,
      } = this;

      state.loginBtn = true;

      const validateFieldsKey = customActiveKey === 'password' ? ['username', 'password', 'vcode'] : ['username', 'password', 'vcode'];

      validateFields(validateFieldsKey, { force: true }, async (err, values) => {
        const postData = { ...values, vid: this.imgVcode.vid, grant: this.customActiveKey };
        if (!err) {
          const res = await login(postData);
          if (res.success) {
            // 登录成功
            this.loginSuccess();
          } else if (res.errCode === 9006) {
            this.$message.error(res.errMessage);
            this.getImgVCode();
          } else if (res.errCode === 401 || res.errCode === 402) {
            this.$message.error(res.errMessage);
          }
        }
      });
    },
    getCaptcha(e) {
      e.preventDefault();
      const { form: { validateFields }, state } = this;

      validateFields(['username'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true;

          const interval = window.setInterval(() => {
            state.time -= 1;
            if (state.time <= 0) {
              state.time = 60;
              state.smsSendBtn = false;
              window.clearInterval(interval);
            }
          }, 1000);

          const hide = this.$message.loading('验证码发送中..', 0);
          sendSmsVcode(values.username).then(() => {
            setTimeout(hide, 2500);
            this.$notification.success({
              message: '提示',
              description: '验证码获取成功',
              duration: 8,
            });
          }).catch((error) => {
            setTimeout(hide, 1);
            clearInterval(interval);
            state.time = 60;
            state.smsSendBtn = false;
            this.requestFailed(error);
          });
        }
      });
    },
    loginSuccess() {
      this.$store.dispatch('getInitData');
      this.$router.push({ path: '/home' });
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: '欢迎回来',
        });
      }, 1000);
      this.isLoginError = false;
    },
    requestFailed(err) {
      this.isLoginError = true;
      this.$notification.error({
        message: '错误',
        description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
        duration: 4,
      });
    },
  },
};
</script>

<style lang="less">
.imgVcode {
  cursor: pointer;
  padding-top: 3px;
  padding-left: 5px;
  .anticon-loading{
    position: absolute;
    left: 50%;
    top: 40%;
  }
  svg{
    width: 100px;
    height: 30px;
  }
}
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
